import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtils } from '@shared/utils';
import {
  AccountsApi,
  RequestStrategyEnum,
  type TransactionsWithPaymentsRequest,
  type TransactionsWithPaymentsResponse,
  type WithSignal,
} from '@shared/api';

const getTransactionsWithPaymentsEffect = createEffect(({ signal, ...request }: WithSignal<TransactionsWithPaymentsRequest>) =>
  AccountsApi.getTransactionsWithPayments(request, signal),
);
const clearEvent = createEvent();

const $dataStore = createStore<{ data: TransactionsWithPaymentsResponse[]; total: number }>({ data: [], total: 0 })
  .on(getTransactionsWithPaymentsEffect.done, (_, data) =>
    data.result ? { data: data.result.data || [], total: data.result.total } : { data: [], total: 0 },
  )
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getTransactionsWithPaymentsEffect.pending, (_, data) => data)
  .on(getTransactionsWithPaymentsEffect.fail, (_, data) => ApiUtils.abortApiLoadingFailCaseTrigger(data.error))
  .on(getTransactionsWithPaymentsEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getTransactionsWithPaymentsEffect, () => null)
  // .on(getTransactionsWithPaymentsEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getTransactionsWithPaymentsEffect.fail, () => 'Something went wrong while fetching Transactions. Please try again.')
  .on(getTransactionsWithPaymentsEffect.done, () => null)
  .reset(clearEvent);

const getTransactionsWithPaymentsApi = ApiUtils.wrapperApi(getTransactionsWithPaymentsEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getTransactionsWithPaymentsApi.cancel());

export const $transactionsWithPaymentsStore = {
  events: {
    getTransactionsWithPayments: getTransactionsWithPaymentsApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
